import http from "../../common/duck/httpService";
import logger from "../../common/duck/logService";
import localStorageService from '../../common/duck/localStorageService';

const apiEndPoint = `/farm/user`;

const { CancelAxiosToken, getDataOrError } = http;

const getFarmsForUserRequest = () => {
    const source = CancelAxiosToken.source();
    let lastMeta = null;

    const request = (q = '', sortType, status, opts = {}) => {
        const userid = localStorageService.getUserId();
        const encodedSearch = encodeURIComponent(q);
        const { page, size, lite, healthStatus, moistureStatus } = opts;
        const params = '?imageRequired=true'
            + (sortType ? '&sort=' + sortType + '&sortorder=DESC' : '')
            + (q ? '&name=' + encodedSearch : '')
            + (status ? '&siteStatus=' + status : '')
            + (lite ? '&lite=true' : '')
            + (healthStatus ? '&healthStatus=' + healthStatus : '')
            + (moistureStatus ? '&moistureStatus=' + moistureStatus : '')
            + (page ? '&page=' + page : '')
            + (size ? '&size=' + size : '');
        return http.get(`${apiEndPoint}/${userid}${params}`, {
            cancelToken: source.token
        }).then(response => {
            lastMeta = response.data.meta || null;
            return response.data.data;
        }).catch(error => {
            if (http.isCancel(error)) {
                return Promise.reject({ isCancelled: true });
            } else {
                const { data } = error.response || {};
                logger.log(error);
                return Promise.reject(data);
            }
        })
    };

    return { request, cancel: source.cancel, getMeta: () => lastMeta }
}

const getBusinessesUnderOrg = (opts = {}) => {
    const qs = opts.lite ? '?type=business&lite=true' : '?type=business';
    return http.get(`/org${qs}`)
        .then(response => {
            return response.data.data;
        }).catch(error => {
            const { data } = error.response || {};
            logger.log(error);
            return Promise.reject(data);
        });
}

const createFarm = (payload) => {
    return http.post('/farm', payload)
        .then(response => getDataOrError(response));
}

const getTreeView = () => {
    const source = CancelAxiosToken.source();
    const request = (sortType, opts = {}) => {
        const userid = localStorageService.getUserId();
        const qp = [];
        if (sortType) qp.push('sort=' + encodeURIComponent(sortType));
        if (opts.lite) qp.push('lite=true');
        const params = qp.length ? '?' + qp.join('&') : '';
        return http.get(`/org/view/${userid}${params}`, {
            cancelToken: source.token
        }).then(response => getDataOrError(response))
            .catch(error => {
                if (http.isCancel(error)) {
                    return Promise.reject({ isCancelled: true });
                } else {
                    const { data } = error.response || {};
                    logger.log(error);
                    return Promise.reject(data);
                }
            });
    }
    return { request, cancel: source.cancel }
}

const saveUserFarm = (payload) => {
    return http.post('/farm-health-report/user', payload)
        .then(response => getDataOrError(response)).catch(error => {
            const { data } = error.response || {};
            logger.log(error);
            return Promise.reject(data);
        });
}

const getUsers = () => {
    return http.get('/farm-health-report/users')
        .then(response => {
            return response.data;
        }).catch(error => {
            const { data } = error.response || {};
            logger.log(error);
            return Promise.reject(data);
        });
}

const deleteUser = (objectId) => {
    return http.delete(`/farm-health-report/user/${objectId}`)
        .then(response => response.data);
}

const editUser = (objectId, payload) => {
    return http.patch(`/farm-health-report/user/${objectId}`, payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            const { data } = error.response || {};
            logger.log(error);
            return Promise.reject(data);
        });
}



export default {
    getFarmsForUserRequest,
    getBusinessesUnderOrg,
    createFarm,
    getTreeView,
    saveUserFarm,
    getUsers,
    deleteUser,
    editUser,
}
